"use client"

import { PopupLayout } from "@/components/common/popup/layout/PopupLayout"
import { nativeBr } from "@/utils/nativeBr"

interface SessionExpirePopupProps {
  onConfirm?: () => void
  handleMessage?: string
}

const SessionExpirePopup = ({ 
  onConfirm, 
  handleMessage = "로그인 후 이용해 주세요."  
}: SessionExpirePopupProps) => {
  const handleConfirm = async () => {
    if (nativeBr.isEnabled) {
      try {
        if (nativeBr.isIOS) {
          await nativeBr.dismiss()
        } else if (nativeBr.isAOS) {
          await nativeBr.DGTsessionExpire()
        }
      } catch (error) {
        console.error("네이티브 브릿지 호출 실패:", error)
      }
    }

    // 추가 콜백 실행
    onConfirm?.()
  }

  return (
    <PopupLayout
      // title="세션 만료"
      buttons={[
        {
          title: "확인",
          onClick: handleConfirm,
        },
      ]}
    >
      <div className="typo-rl-body1 text-rl-gray-900 text-center">
        {handleMessage}
      </div>
    </PopupLayout>
  )
}

export default SessionExpirePopup
